import axios from "axios";
import { react, useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../../../config/axios";
import { handleErrorToast } from "../../CustomFunctions";
import { Modal } from "react-bootstrap";
import { AddwithWhiteCircle, UpdatePencil, DeleteDustbin } from "../../AllSvg";

const AddAttendanceSetupModal = ({ SUPER_ADMIN, SUB_COMPANIES, subCompanyId, refreshData, existingConfig }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});
    const [buffer, setBuffering] = useState(true);
    const [weightagesList, setWeightagesList] = useState([]);
    const [letterConfigs, setLetterConfigs] = useState([]);

    const handleShow = () => {
        setShow(true);
    }

    const initialData = {
        sub_company: (subCompanyId && subCompanyId !== "null") ? subCompanyId : sessionStorage.getItem('company_id'),
        star_performance_overall_marks: "",
        star_performance_name: "",
        total_marks: "",
        absent_deduction: "",
        half_day_deduction: "",
        late_deduction: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);

    const handleClose = () => {
        setFormData({
            sub_company: (subCompanyId && subCompanyId !== "null") ? subCompanyId : sessionStorage.getItem('company_id'),
            star_performance_overall_marks: "",
            star_performance_name: "",
            total_marks: "",
            absent_deduction: "",
            half_day_deduction: "",
            late_deduction: "",
            created_by: sessionStorage.getItem('emp_code'),
            updated_by: sessionStorage.getItem('emp_code'),
        })
        setShow(false);
    }

    useEffect(() => { setFormData(existingConfig || initialData); }, [existingConfig, typeof subCompanyId !== "undefined" ? subCompanyId : null]);

    useEffect(() => {
        const fetchDependencies = async () => {
            if (formData.sub_company && formData.sub_company !== "null") {
                try {
                    const weightageRes = await axios.get(`${BASE_URL}/wfm/kra-and-star-performance-module-markings-filter-by-sub-company/?sub_company=${formData.sub_company}`);
                    setWeightagesList(Array.isArray(weightageRes.data) ? weightageRes.data : []);

                    const letterRes = await axios.get(`${BASE_URL}/wfm/star-performance-letter-config-filter-by-sub-company/?sub_company=${formData.sub_company}`);
                    setLetterConfigs(Array.isArray(letterRes.data) ? letterRes.data : []);
                } catch (error) {
                    console.error("Error fetching dependencies", error);
                }
            } else {
                setWeightagesList([]);
                setLetterConfigs([]);
            }
        };
        fetchDependencies();
    }, [formData.sub_company]);

    const handleWeightageChange = (e) => {
        const selectedId = e.target.value;
        const weightage = weightagesList.find(w => w.id === selectedId);

        if (weightage) {
            setFormData(prev => ({
                ...prev,
                star_performance_overall_marks: weightage.id,
                star_performance_name: weightage.name
            }));
            setErrors(prev => {
                const updated = { ...prev };
                delete updated.star_performance_overall_marks;
                return updated;
            });
        } else {
            setFormData(prev => ({
                ...prev,
                star_performance_overall_marks: "",
                star_performance_name: ""
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["total_marks", "absent_deduction", "sub_company", "half_day_deduction", "late_deduction", "star_performance_overall_marks"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required !`;
            }
        });

        if (formData.star_performance_overall_marks && formData.total_marks) {
            const weightage = weightagesList.find(w => w.id === formData.star_performance_overall_marks) || existingConfig?.weightage_data;
            if (weightage) {
                const letterConfig = letterConfigs.find(l => l.star_performance_overall_marks === weightage.id || l.star_performance_name === weightage.name);

                let existingLetterMarks = 0;
                if (letterConfig) {
                    existingLetterMarks = Number(letterConfig.total_marks);
                }

                const expectedAttendanceMarks = Number(weightage.overall_marks) - existingLetterMarks;

                if (letterConfig && Number(formData.total_marks) !== expectedAttendanceMarks) {
                    newErrors.total_marks = `Letter setup already uses ${existingLetterMarks} marks. Attendance marks MUST be exactly ${expectedAttendanceMarks} so they sum up to ${weightage.overall_marks}.`;
                } else if (!letterConfig && Number(formData.total_marks) > Number(weightage.overall_marks)) {
                    newErrors.total_marks = `Attendance marks cannot exceed the total Weightage marks (${weightage.overall_marks}). Remaining marks will be for Letter Setup.`;
                }
            }
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };



    const handleChange = (e) => {
        const { name, value } = e.target;

        const numericFields = [
            "total_marks",
            "late_deduction",
            "half_day_deduction",
            "absent_deduction",
        ];

        if (numericFields.includes(name) && Number(value) < 0) {
            return;
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });


        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {

            setLoading(true);
            setBuffering(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            try {

                if (existingConfig?.id) {
                    const put_result = await axios.put(`${BASE_URL}/wfm/star-performance-attendance-rating-config/${existingConfig.id}/`, formData);
                    if (put_result.status === 200 || put_result.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success(" Updated successfully!");
                    }
                } else {
                    const post_result = await axios.post(`${BASE_URL}/wfm/star-performance-attendance-rating-config/`, formData);
                    if (post_result.status === 200 || post_result.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success(" Created successfully!");
                    }
                }

            } catch (error) {
                handleErrorToast(error, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            {existingConfig?.id ? (
                <>
                    <button className="model-edit-button" title="Update Dynamic Nature" onClick={handleShow}>
                        <UpdatePencil />
                    </button>
                    <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                        <Modal.Header closeButton>
                            <Modal.Title>Update Attendance Configure</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="parent-div">
                                <div className="bdy-div">

                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleChange}
                                                className={`form-input w-auto ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Weightage Configuration <span className="required">*</span>
                                        </label>
                                        <select
                                            name="star_performance_overall_marks"
                                            value={formData.star_performance_overall_marks}
                                            onChange={handleWeightageChange}
                                            className={`form-input w-auto ${errors.star_performance_overall_marks ? "error" : ""}`}
                                            required
                                        >
                                            <option value="">Select Weightage</option>
                                            {weightagesList.map((w, index) => (
                                                <option key={index} value={w.id}>
                                                    {w.name} ({w.overall_marks} Marks)
                                                </option>
                                            ))}
                                        </select>
                                        {errors.star_performance_overall_marks && (
                                            <span className="error-message font-size-text">
                                                {errors.star_performance_overall_marks}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Total Score <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="total_marks"
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.total_marks}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.total_marks ? 'error' : ''}`}
                                            placeholder="e.g. 10"
                                        />
                                        {errors.total_marks && <span className="error-message font-size-text" >{errors.total_marks}</span>}
                                    </div>

                                    <div className="flex-column ">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Late Coming Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="late_deduction"
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.late_deduction}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.late_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.25"
                                        />
                                        {errors.late_deduction && <span className="error-message font-size-text" >{errors.late_deduction}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Halfday Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="half_day_deduction"
                                            value={formData.half_day_deduction}
                                            onChange={handleChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`form-input w-auto ${errors.half_day_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.25"
                                        />
                                        {errors.half_day_deduction && <span className="error-message font-size-text" >{errors.half_day_deduction}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Absent Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="absent_deduction"
                                            value={formData.absent_deduction}
                                            onChange={handleChange}
                                            onWheel={(e) => e.target.blur()}
                                            className={`form-input w-auto ${errors.absent_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.50"
                                        />
                                        {errors.absent_deduction && <span className="error-message font-size-text" >{errors.absent_deduction}</span>}
                                    </div>

                                    <div className="button-models">
                                        <button className="model-button model-button-cancel  font-weight500" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            Update
                                        </button>
                                    </div>


                                </div>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                        </Modal.Body>
                    </Modal>
                </>
            )
                :
                <>
                    <button className="upload-svg" onClick={handleShow} title="Add Attendance Configure">
                        <AddwithWhiteCircle /> Attendance Configure
                    </button>
                    <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                        <Modal.Header closeButton>
                            <Modal.Title>Add Attendance Configure</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="parent-div">
                                <div className="bdy-div">

                                    {SUPER_ADMIN && (
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Sub Company<span className="required">*</span>
                                            </label>
                                            <select
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleChange}
                                                className={`form-input w-auto ${errors.sub_company
                                                    ? "error"
                                                    : inputState.sub_company
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                required
                                            >
                                                <option value="">Select a Company</option>
                                                {SUB_COMPANIES.map((i, index) => (
                                                    <option key={index} value={i.id}>
                                                        {i.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sub_company && (
                                                <span className="error-message font-size-text ">
                                                    {errors.sub_company}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Weightage Configuration <span className="required">*</span>
                                        </label>
                                        <select
                                            name="star_performance_overall_marks"
                                            value={formData.star_performance_overall_marks}
                                            onChange={handleWeightageChange}
                                            className={`form-input w-auto ${errors.star_performance_overall_marks ? "error" : ""}`}
                                            required
                                        >
                                            <option value="">Select Weightage</option>
                                            {weightagesList.map((w, index) => (
                                                <option key={index} value={w.id}>
                                                    {w.name} ({w.overall_marks} Marks)
                                                </option>
                                            ))}
                                        </select>
                                        {errors.star_performance_overall_marks && (
                                            <span className="error-message font-size-text">
                                                {errors.star_performance_overall_marks}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Total Score <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            step="any"
                                            onWheel={(e) => e.target.blur()}
                                            name="total_marks"
                                            value={formData.total_marks}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.total_marks ? 'error' : ''}`}
                                            placeholder="e.g. 10"
                                        />
                                        {errors.total_marks && <span className="error-message font-size-text" >{errors.total_marks}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Late Coming Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            step="any"
                                            name="late_deduction"
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.late_deduction}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.late_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.25"
                                        />
                                        {errors.late_deduction && <span className="error-message font-size-text" >{errors.late_deduction}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Halfday Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            step="any"
                                            name="half_day_deduction"
                                            onWheel={(e) => e.target.blur()}
                                            value={formData.half_day_deduction}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.half_day_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.25"
                                        />
                                        {errors.half_day_deduction && <span className="error-message font-size-text" >{errors.half_day_deduction}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Absent Deduction <span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            step="any"
                                            name="absent_deduction"
                                            value={formData.absent_deduction}
                                            onWheel={(e) => e.target.blur()}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.absent_deduction ? 'error' : ''}`}
                                            placeholder="e.g. 0.50"
                                        />
                                        {errors.absent_deduction && <span className="error-message font-size-text" >{errors.absent_deduction}</span>}
                                    </div>

                                    <div className="button-models">
                                        <button className="model-button model-button-cancel  font-weight500" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            Add
                                        </button>
                                    </div>


                                </div>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                        </Modal.Body>
                    </Modal>
                </>
            }

        </>
    );
};

const DeleteAttendanceSetupModal = ({ existingConfig, refreshData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async (e) => {
        if (!existingConfig?.id) return;
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/star-performance-attendance-rating-config/${existingConfig.id}/`);
            if (res.status === 200) {
                await refreshData();
                setShow(false);
                toast.success("Deleted Successfully!");
            }
        } catch (error) {
            handleErrorToast(error, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                className="model-delete-button"
                title="Delete Configuration"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <h6 className="font-weight500 font-size-heading mb-4 text-center">
                            Are you sure you want to delete this attendance configuration?
                        </h6>
                        <div className="button-models mt-4">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button
                                className="model-button font-weight500 model-button-delete"
                                onClick={handleDelete}
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const AddWeightageSetupModal = ({ SUPER_ADMIN, SUB_COMPANIES, subCompanyId, refreshData, existingConfig }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});

    const handleShow = () => setShow(true);

    const initialData = {
        sub_company: (subCompanyId && subCompanyId !== "null") ? subCompanyId : sessionStorage.getItem('company_id'),
        name: "",
        overall_marks: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    };
    const [formData, setFormData] = useState(initialData);

    const handleClose = () => {
        setFormData(initialData);
        setShow(false);
    };

    useEffect(() => { setFormData(existingConfig || initialData); }, [existingConfig, typeof subCompanyId !== "undefined" ? subCompanyId : null]);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["name", "overall_marks", "sub_company"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')} is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "overall_marks" && Number(value) < 0) {
            return;
        }
        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Saving configuration...");
            try {
                if (existingConfig?.id) {
                    const res = await axios.put(`${BASE_URL}/wfm/kra-and-star-performance-module-markings/${existingConfig.id}/`, formData);
                    if (res.status === 200 || res.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success("Updated successfully!");
                    }
                } else {
                    const res = await axios.post(`${BASE_URL}/wfm/kra-and-star-performance-module-markings/`, formData);
                    if (res.status === 200 || res.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success("Created successfully!");
                    }
                }
            } catch (error) {
                handleErrorToast(error, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            {existingConfig?.id ? (
                <button className="model-edit-button" title="Update Weightage Setup" onClick={handleShow}>
                    <UpdatePencil />
                </button>
            ) : (
                <button className="upload-svg" onClick={handleShow} title="Add Weightage Configuration">
                    <AddwithWhiteCircle /> Add Weightage
                </button>
            )}

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>{existingConfig?.id ? "Update" : "Add"} Weightage Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>{i.title}</option>
                                        ))}
                                    </select>
                                    {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                                </div>
                            )}

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className={`form-input w-auto ${errors.name ? 'error' : ''}`}
                                    placeholder="e.g. KRA"
                                />
                                {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
                            </div>

                            <div className="flex-column mb-3">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Overall Marks <span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    step="any"
                                    name="overall_marks"
                                    value={formData.overall_marks}
                                    onChange={handleChange}
                                    className={`form-input w-auto ${errors.overall_marks ? 'error' : ''}`}
                                    placeholder="e.g. 100"
                                />
                                {errors.overall_marks && <span className="error-message font-size-text">{errors.overall_marks}</span>}
                            </div>

                            <div className="button-models mt-4">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleSubmit} disabled={loading}>
                                    {existingConfig?.id ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteWeightageSetupModal = ({ existingConfig, refreshData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async () => {
        if (!existingConfig?.id) return;
        setLoading(true);
        const toastId = toast.loading("Deleting configuration...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/kra-and-star-performance-module-markings/${existingConfig.id}/`);
            if (res.status === 200 || res.status === 204) {
                toast.update(toastId, { render: "Deleted successfully!", type: "success", isLoading: false, autoClose: 3000 });
                await refreshData();
                handleClose();
            }
        } catch (error) {
            handleErrorToast(error, toastId);
        } finally {
            setLoading(false);
            toast.dismiss(toastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" title="Delete Configuration" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <h6 className="font-weight500 font-size-heading mb-4 text-center">
                            Are you sure you want to delete this weightage configuration?
                        </h6>
                        <div className="button-models mt-4">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleDelete} disabled={loading} style={{ backgroundColor: 'red', color: 'white' }}>
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const AddLetterSetupModal = ({ SUPER_ADMIN, SUB_COMPANIES, subCompanyId, refreshData, existingConfig }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});
    const [weightagesList, setWeightagesList] = useState([]);
    const [attendanceConfigs, setAttendanceConfigs] = useState([]);

    const handleShow = () => setShow(true);

    const initialData = {
        sub_company: (subCompanyId && subCompanyId !== "null") ? subCompanyId : sessionStorage.getItem('company_id'),
        total_marks: "",
        star_performance_overall_marks: "",
        default_marks: "",
        client_appriciation_marks: "",
        team_appriciation_marks: "",
        client_warning_marks: "",
        team_warning_marks: "",
        pip_warning_marks: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    };
    const [formData, setFormData] = useState(initialData);

    const handleClose = () => {
        setFormData(initialData);
        setShow(false);
    };

    useEffect(() => { setFormData(existingConfig || initialData); }, [existingConfig, typeof subCompanyId !== "undefined" ? subCompanyId : null]);

    useEffect(() => {
        const fetchDependencies = async () => {
            if (formData.sub_company && formData.sub_company !== "null") {
                try {
                    const weightageRes = await axios.get(`${BASE_URL}/wfm/kra-and-star-performance-module-markings-filter-by-sub-company/?sub_company=${formData.sub_company}`);
                    setWeightagesList(Array.isArray(weightageRes.data) ? weightageRes.data : []);

                    const attendanceRes = await axios.get(`${BASE_URL}/wfm/star-performance-attendance-rating-config-filter-by-sub-company/?sub_company=${formData.sub_company}`);
                    setAttendanceConfigs(Array.isArray(attendanceRes.data) ? attendanceRes.data : []);
                } catch (error) {
                    console.error("Error fetching dependencies", error);
                }
            } else {
                setWeightagesList([]);
                setAttendanceConfigs([]);
            }
        };
        fetchDependencies();
    }, [formData.sub_company]);

    const handleWeightageChange = (e) => {
        const selectedId = e.target.value;
        const weightage = weightagesList.find(w => w.id === selectedId);

        if (weightage) {
            setFormData(prev => ({
                ...prev,
                star_performance_overall_marks: weightage.id,
                star_performance_name: weightage.name
            }));
            setErrors(prev => {
                const updated = { ...prev };
                delete updated.star_performance_overall_marks;
                return updated;
            });
        } else {
            setFormData(prev => ({
                ...prev,
                star_performance_overall_marks: "",
                star_performance_name: ""
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "total_marks",
            "default_marks",
            "client_appriciation_marks",
            "team_appriciation_marks",
            "client_warning_marks",
            "team_warning_marks",
            "pip_warning_marks",
            "sub_company",
            "star_performance_overall_marks"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required !`;
            }
        });

        if (formData.star_performance_overall_marks && formData.total_marks) {
            const weightage = weightagesList.find(w => w.id === formData.star_performance_overall_marks) || existingConfig?.weightage_data;
            if (weightage) {
                const attendanceConfig = attendanceConfigs.find(a => a.star_performance_overall_marks === weightage.id || a.star_performance_name === weightage.name);

                let existingAttendanceMarks = 0;
                if (attendanceConfig) {
                    existingAttendanceMarks = Number(attendanceConfig.total_marks);
                }

                const expectedLetterMarks = Number(weightage.overall_marks) - existingAttendanceMarks;

                if (attendanceConfig && Number(formData.total_marks) !== expectedLetterMarks) {
                    newErrors.total_marks = `Attendance setup already uses ${existingAttendanceMarks} marks. Letter marks MUST be exactly ${expectedLetterMarks} so they sum up to ${weightage.overall_marks}.`;
                } else if (!attendanceConfig && Number(formData.total_marks) > Number(weightage.overall_marks)) {
                    newErrors.total_marks = `Letter marks cannot exceed the total Weightage marks (${weightage.overall_marks}).`;
                }
            }
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "total_marks",
            "default_marks",
            "client_appriciation_marks",
            "team_appriciation_marks",
            "client_warning_marks",
            "team_warning_marks",
            "pip_warning_marks"
        ];

        if (numericFields.includes(name) && Number(value) < 0) {
            return;
        }
        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[name];
            return updated;
        });
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Saving configuration...");
            try {
                if (existingConfig?.id) {
                    const res = await axios.put(`${BASE_URL}/wfm/star-performance-letter-config/${existingConfig.id}/`, formData);
                    if (res.status === 200 || res.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success("Updated successfully!");
                    }
                } else {
                    const res = await axios.post(`${BASE_URL}/wfm/star-performance-letter-config/`, formData);
                    if (res.status === 200 || res.status === 201) {
                        await refreshData();
                        setShow(false);
                        setFormData(initialData);
                        toast.success("Created successfully!");
                    }
                }
            } catch (error) {
                handleErrorToast(error, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            {existingConfig?.id ? (
                <button className="model-edit-button" title="Update Letter Setup" onClick={handleShow}>
                    <UpdatePencil />
                </button>
            ) : (
                <button className="upload-svg" onClick={handleShow} title="Add Letter Configuration">
                    <AddwithWhiteCircle /> Add Letter Config
                </button>
            )}

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
                <Modal.Header closeButton>
                    <Modal.Title>{existingConfig?.id ? "Update" : "Add"} Letter Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="row">
                                {SUPER_ADMIN && (
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <select
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleChange}
                                            className={`form-input w-auto ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                                            required
                                        >
                                            <option value="">Select a Company</option>
                                            {SUB_COMPANIES.map((i, index) => (
                                                <option key={index} value={i.id}>{i.title}</option>
                                            ))}
                                        </select>
                                        {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                                    </div>
                                )}

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Weightage Configuration <span className="required">*</span>
                                    </label>
                                    <select
                                        name="star_performance_overall_marks"
                                        value={formData.star_performance_overall_marks}
                                        onChange={handleWeightageChange}
                                        className={`form-input w-auto ${errors.star_performance_overall_marks ? "error" : ""}`}
                                        required
                                    >
                                        <option value="">Select Weightage</option>
                                        {weightagesList.map((w, index) => (
                                            <option key={index} value={w.id}>
                                                {w.name} ({w.overall_marks} Marks)
                                            </option>
                                        ))}
                                    </select>
                                    {errors.star_performance_overall_marks && (
                                        <span className="error-message font-size-text">{errors.star_performance_overall_marks}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Total Score <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="total_marks"
                                        value={formData.total_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.total_marks ? 'error' : ''}`}
                                        placeholder="e.g. 20"
                                    />
                                    {errors.total_marks && <span className="error-message font-size-text">{errors.total_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Default/Base Score <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="default_marks"
                                        value={formData.default_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.default_marks ? 'error' : ''}`}
                                        placeholder="e.g. 10"
                                    />
                                    {errors.default_marks && <span className="error-message font-size-text">{errors.default_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Client Appreciation Additions <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="client_appriciation_marks"
                                        value={formData.client_appriciation_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.client_appriciation_marks ? 'error' : ''}`}
                                        placeholder="e.g. 4"
                                    />
                                    {errors.client_appriciation_marks && <span className="error-message font-size-text">{errors.client_appriciation_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Team Appreciation Additions <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="team_appriciation_marks"
                                        value={formData.team_appriciation_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.team_appriciation_marks ? 'error' : ''}`}
                                        placeholder="e.g. 2"
                                    />
                                    {errors.team_appriciation_marks && <span className="error-message font-size-text">{errors.team_appriciation_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Client Warning Deductions <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="client_warning_marks"
                                        value={formData.client_warning_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.client_warning_marks ? 'error' : ''}`}
                                        placeholder="e.g. 4"
                                    />
                                    {errors.client_warning_marks && <span className="error-message font-size-text">{errors.client_warning_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Team Warning Deductions <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="team_warning_marks"
                                        value={formData.team_warning_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.team_warning_marks ? 'error' : ''}`}
                                        placeholder="e.g. 2"
                                    />
                                    {errors.team_warning_marks && <span className="error-message font-size-text">{errors.team_warning_marks}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        PIP Letter Deductions <span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        name="pip_warning_marks"
                                        value={formData.pip_warning_marks}
                                        onChange={handleChange}
                                        className={`form-input w-auto ${errors.pip_warning_marks ? 'error' : ''}`}
                                        placeholder="e.g. 2"
                                    />
                                    {errors.pip_warning_marks && <span className="error-message font-size-text">{errors.pip_warning_marks}</span>}
                                </div>

                            </div>

                            <div className="button-models mt-4">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleSubmit} disabled={loading}>
                                    {existingConfig?.id ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteLetterSetupModal = ({ existingConfig, refreshData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDelete = async () => {
        if (!existingConfig?.id) return;
        setLoading(true);
        const toastId = toast.loading("Deleting configuration...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/star-performance-letter-config/${existingConfig.id}/`);
            if (res.status === 200 || res.status === 204) {
                toast.update(toastId, { render: "Deleted successfully!", type: "success", isLoading: false, autoClose: 3000 });
                await refreshData();
                handleClose();
            }
        } catch (error) {
            handleErrorToast(error, toastId);
        } finally {
            setLoading(false);
            toast.dismiss(toastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" title="Delete Configuration" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Configuration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <h6 className="font-weight500 font-size-heading mb-4 text-center">
                            Are you sure you want to delete this letter configuration?
                        </h6>
                        <div className="button-models mt-4">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                Cancel
                            </button>
                            <button className="model-button font-weight500 model-button-leave font-size-heading" onClick={handleDelete} disabled={loading} style={{ backgroundColor: 'red', color: 'white' }}>
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { AddAttendanceSetupModal, DeleteAttendanceSetupModal, AddWeightageSetupModal, DeleteWeightageSetupModal, AddLetterSetupModal, DeleteLetterSetupModal };

